import React from 'react';
import DENTToothSurface from './DENTToothSurface';
import { ToothViewData } from './teethData';
import { Tooth, ToothState } from '../../../../graphql/graphql';
import separateDecayTypeSurfaces from '../../Helpers/pathology/separateDecayTypeSurfaces';
import DENTToothRestorationSurfaces from '../ToothVisual/DENTToothRestorationSurfaces';

interface Props {
	data: Tooth;
	toothViewData: ToothViewData;
}

const DENTToothSurfaces: React.FC<Props> = ({ data, toothViewData }) => {
	const showPathology =
		data.state === ToothState.Normal || data.state === ToothState.ToBeExtracted;

	const { primaryDecaySurfaces, secondaryDecaySurfaces } =
		separateDecayTypeSurfaces(data.pathology);

	const secondaryDecayOutlineProps = {
		strokeWidth: 5,
		strokeDasharray: '10 5',
		stroke: '#ff0000',
	};

	return (
		<>
			<DENTToothRestorationSurfaces
				toothViewData={toothViewData}
				tooth={data}
			/>
			{showPathology && (
				<g opacity='0.4'>
					{primaryDecaySurfaces.map((surface, index) => (
						<DENTToothSurface
							key={index}
							toothViewData={toothViewData}
							surface={surface}
							color='#ff0000'
						/>
					))}
					{secondaryDecaySurfaces.map((surface, index) => (
						<DENTToothSurface
							key={index}
							toothViewData={toothViewData}
							surface={surface}
							outlineProps={secondaryDecayOutlineProps}
						/>
					))}
				</g>
			)}
		</>
	);
};

export default DENTToothSurfaces;
